import { PortalId } from "@shared/models/portal.id.model";

export const ID : PortalId = {
    id: 'scorewater' 
}